import React from 'react'
import MicroFrontend from '../MicroFrontend'

export const microFrontendFactory = (host: string, name: string) => {
  const Component = () => <MicroFrontend host={host} name={name} />
  Component.displayName = `${name}Microfrontend`

  return Component
}
